export default {
  emitir: state => state.servicoEmpresa.crachaAmbulante.emitir
};
